import { Box, ResponsiveLayout } from "@bca/ui-library";
import React, { useState, useEffect } from "react";

import BackToResultsButton from "./BackToResultsButton";

const BackToResultsStrip: React.FC<{
  vrm: string;
}> = (vrm) => {
  const [shouldReturnToPage, setShouldReturnToPage] =
    useState(false);

  useEffect(() => {
    const searchParams = new URL(window.location.href).searchParams.toString();
    if (
      searchParams.includes("searchVersion=new") ||
      searchParams.includes("vdr=vp") ||
      searchParams.includes("source=AuctionManagementVehicles")
    ) {
      setShouldReturnToPage(true);
    }
  }, []);

  return (
    shouldReturnToPage && (
      <Box height="60px" width="100%" backgroundColor="#080f22" display="flex">
        <ResponsiveLayout
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <BackToResultsButton vrm={vrm} />
        </ResponsiveLayout>
      </Box>
    )
  );
};

export default BackToResultsStrip;
